import { render, staticRenderFns } from "./dashboard-ignis.vue?vue&type=template&id=0782b197&scoped=true"
import script from "./dashboard-ignis.vue?vue&type=script&lang=js"
export * from "./dashboard-ignis.vue?vue&type=script&lang=js"
import style0 from "./dashboard-ignis.vue?vue&type=style&index=0&id=0782b197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0782b197",
  null
  
)

export default component.exports